var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 1.23284C19.5 0.632672 19.0147 0.149506 18.4167 0.149506H1.08333C0.485333 0.149506 0 0.632672 0 1.23284V18.5662C0 19.1642 0.485333 19.6495 1.08333 19.6495H18.4167C19.0147 19.6495 19.5 19.1642 19.5 18.5662V1.23284Z",
    fill: "#2A84F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 26C19.5 25.402 19.0147 24.9167 18.4167 24.9167H1.08333C0.485333 24.9167 0 25.402 0 26V43.3333C0 43.9313 0.485333 44.4167 1.08333 44.4167H18.4167C19.0147 44.4167 19.5 43.9313 19.5 43.3333V26Z",
    fill: "#2A84F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5 1.08333C45.5 0.485333 45.0147 0 44.4167 0H27.0833C26.4853 0 26 0.485333 26 1.08333V18.4167C26 19.0147 26.4853 19.5 27.0833 19.5H44.4167C45.0147 19.5 45.5 19.0147 45.5 18.4167V1.08333Z",
    fill: "#2A84F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.666 26V43.3333C34.666 43.9313 35.1514 44.4167 35.7494 44.4167C36.3474 44.4167 36.8327 43.9313 36.8327 43.3333V26C36.8327 25.402 36.3474 24.9167 35.7494 24.9167C35.1514 24.9167 34.666 25.402 34.666 26Z",
    fill: "#F9B815"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0833 35.75H44.4167C45.0147 35.75 45.5 35.2647 45.5 34.6667C45.5 34.0687 45.0147 33.5833 44.4167 33.5833H27.0833C26.4853 33.5833 26 34.0687 26 34.6667C26 35.2647 26.4853 35.75 27.0833 35.75Z",
    fill: "#F9B815"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon-11.7f85c3d7c4546a1da47dc21e3bbbfbfa.svg";
export { ForwardRef as ReactComponent };